import { Box, Image, SimpleGrid } from "@chakra-ui/react";
import SchoolBanner from "@/assets/images/creator_img6.png";
import SchoolItemImg from "@/assets/images/creator_img4.png";
import CreativitySchoolItem from "@/components/creatorcenter/creativityschoolitem";
import { Courses } from "@/types/creatorcenter";

const SchoolOfCreativity = ()=> {
  const CoursesList: Courses[] = [
    {
      id: "1",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
      tag: "训练营"
    },
    {
      id: "2",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "3",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
      tag: "认证课"
    },
    {
      id: "4",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
    {
      id: "5",
      product_name: "AIGC全能课的实战应用",
      img_url: `${SchoolItemImg}`,
      avatar_url: "",
      username: "阿发个前滚翻噶",
      starttime: "04月24日 20:30直播",
    },
  ];
  
  return (
    <Box h="100%" pl="20px" pr="20px" overflow={"auto"}>
      <Box>
        <Image w="100%" src={SchoolBanner} />
      </Box>

      <Box borderWidth="1px" borderColor={"#DCE0EB"} p="20px" mt="20px">
        <Box mb="20px" fontSize={"18px"} fontWeight="bold" color={"#27314D"}>
          官方课程
        </Box>
        <SimpleGrid columns={5} spacing={"20px"}>
          {CoursesList.map((item) => {
            return (
              <Box key={item.id}>
                <CreativitySchoolItem courses={item} />
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
      
    </Box>
  )
}

export default SchoolOfCreativity;